import { z } from 'zod';
import { MutableRefObject } from 'react';
import { equipmentFormSchema } from '../model';
import { CreateEquipmentVariables, UpdateEquipmentVariables } from '../api/equipment/types';

export type EquipmentFormValue = z.infer<typeof equipmentFormSchema>;

export const enum EquipmentFormMode {
  Create = 'create',
  Update = 'update',
}

export interface CreateUpdateEquipmentDialogData {
  equipmentId: string | undefined;
  onCancel?: VoidFunction;
  submitRef?: MutableRefObject<{ submit: () => EquipmentFormValue } | null>;
  onSubmit?: (data: {
    form: EquipmentFormValue;
    createDTO: Omit<CreateEquipmentVariables['input'], 'dynamicsVendorOpportunityId' | 'vendorOpportunityId'>;
    updateDTO: Omit<UpdateEquipmentVariables['input'], 'dynamicsVendorOpportunityId' | 'vendorOpportunityId'>;
  }) => void;
}
